import React from 'react';
import Marquee from './Marquee';
import { CookiesProvider } from 'react-cookie';

export default function MarqueeWithCookies() {
  return (
    <CookiesProvider>
      <Marquee />
    </CookiesProvider>
  );
}



// WEBPACK FOOTER //
// ./src/components/Marquee/MarqueeWithCookies.js